document.addEventListener('DOMContentLoaded', function () {
  const component = document.querySelector('slide-hero-custom-component');
  if (!component) return;

  const slider = component.querySelector('.slider');
  const slides = slider.querySelectorAll('.slider__slide');
  const prevButton = component.querySelector('button[name="previous"]');
  const nextButton = component.querySelector('button[name="next"]');
  let currentIndex = 0;

  function goToSlide(index) {
  // Wrap around for infinite looping
  currentIndex = (index + slides.length) % slides.length;

  const slide = slides[currentIndex];
  slider.scrollTo({
    left: slide.offsetLeft,
    behavior: 'smooth',
  });
}


  prevButton.addEventListener('click', () => {
    goToSlide(currentIndex - 1);
  });

  nextButton.addEventListener('click', () => {
    goToSlide(currentIndex + 1);
  });

  // Optional autoplay
  const autoplay = component.dataset.autoplay === 'true';
  const speed = parseInt(component.dataset.speed) || 5000;
  let autoplayInterval;

  if (autoplay) {
    autoplayInterval = setInterval(() => {
      goToSlide(currentIndex + 1);
    }, speed);

    component.pause = () => clearInterval(autoplayInterval);
    component.play = () => {
      clearInterval(autoplayInterval);
      autoplayInterval = setInterval(() => {
        goToSlide(currentIndex + 1);
      }, speed);
    };
  } else {
    component.pause = () => {};
    component.play = () => {};
  }

  component.slider = slider;
});
